import { VIDEOS } from '../data'

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
}

export default function Videos() {
  return (
    <main style={{ minHeight: '100vh', padding: 'clamp(48px, 8vw, 80px) clamp(16px, 5vw, 32px)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ marginBottom: '64px', paddingBottom: '24px', borderBottom: '1px solid var(--border)' }}>
          <div className="section-label">Watch</div>
          <h1 className="section-title">Videos</h1>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
            gap: '24px',
          }}
        >
          {VIDEOS.map((video) => (
            <div key={video.id}>
              {/* YouTube embed */}
              <div
                style={{
                  position: 'relative',
                  paddingBottom: '56.25%',
                  height: 0,
                  overflow: 'hidden',
                  background: '#1a1008',
                  marginBottom: '14px',
                }}
              >
                <iframe
                  src={`https://www.youtube.com/embed/${video.youtubeId}`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 'none',
                  }}
                />
              </div>

              <h2
                style={{
                  fontFamily: 'var(--font-display)',
                  fontWeight: 500,
                  fontSize: '15px',
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  color: 'var(--cream)',
                  marginBottom: '6px',
                }}
              >
                {video.title}
              </h2>
              <p
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '10px',
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                  color: 'var(--gold-dim)',
                }}
              >
                {formatDate(video.date)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </main>
  )
}
